export const CircleTickIcon = ({
  strokeColor = "var(--color-green)",
  ...props
}: any) => (
  <svg
    {...props}
    width={props.width ? props.width : "100"}
    height={props.width ? props.width : "100"}
    viewBox="0 0 100 100"
    fill="none"
  >
    <g id="vuesax/outline/tick-circle">
      <g id="tick-circle">
        <path
          id="Vector"
          d="M50.0006 94.7923C25.2923 94.7923 5.20898 74.709 5.20898 50.0006C5.20898 25.2923 25.2923 5.20898 50.0006 5.20898C74.709 5.20898 94.7923 25.2923 94.7923 50.0006C94.7923 74.709 74.709 94.7923 50.0006 94.7923ZM50.0006 11.459C28.7507 11.459 11.459 28.7507 11.459 50.0006C11.459 71.2506 28.7507 88.5423 50.0006 88.5423C71.2506 88.5423 88.5423 71.2506 88.5423 50.0006C88.5423 28.7507 71.2506 11.459 50.0006 11.459Z"
          fill={strokeColor}
        />
        <path
          id="Vector_2"
          d="M44.084 64.9173C43.2507 64.9173 42.459 64.584 41.8757 64.0007L30.084 52.209C28.8757 51.0007 28.8757 49.0007 30.084 47.7923C31.2923 46.584 33.2923 46.584 34.5007 47.7923L44.084 57.3757L65.5007 35.959C66.709 34.7507 68.709 34.7507 69.9173 35.959C71.1257 37.1673 71.1257 39.1673 69.9173 40.3756L46.2923 64.0007C45.709 64.584 44.9173 64.9173 44.084 64.9173Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
